import { Link2 } from 'lucide-react';
import { IntegrationProvider } from '@momentum/types';
import confluenceIcon from '@/features/knowledge/assets/confluence.svg';

export const JiraLogo = () => (
  <img src="/jira-logo.svg" alt="" className="h-10 w-10" />
);

export const LinearLogo = () => (
  <img src="/linear-logo.svg" alt="" className="h-10 w-10" />
);

export const MondayLogo = () => (
  <img src="/monday-logo.svg" alt="" className="h-10 w-10" />
);

export const SalesforceLogo = () => (
  <img src="/salesforce-logo.svg" alt="" className="h-10 w-12" />
);

export const SlackLogo = () => (
  <img src="/slack-logo.svg" alt="" className="h-10 w-10" />
);

export const MsProjectLogo = () => (
  <img src="/msproject-icon.svg" alt="" className="h-10 w-10" aria-hidden />
);

export const BambooHRLogo = () => (
  <img src="/bamboohr-logo.svg" alt="" className="h-10 w-10" />
);

export const SharePointLogo = () => (
  <img src="/sharepoint-logo.svg" alt="" className="h-10 w-10" />
);

export const DynamicsCrmLogo = () => (
  <img src="/dynamics-crm-logo.svg" alt="" className="h-10 w-10" />
);

export const ConfluenceLogo = () => (
  <img src={confluenceIcon} alt="" className="h-10 w-10" />
);

export const MicrosoftTeamsLogo = () => (
  <img src="/teams-logo.svg" alt="" className="h-10 w-10" />
);

export const GoogleDriveLogo = () => (
  <img src="/gdrive-logo.svg" alt="" className="h-10 w-10" />
);

export const NotionLogo = () => (
  <img src="/notion-logo.svg" alt="" className="h-10 w-10" />
);

export const GitHubLogo = () => (
  <img src="/github-logo.svg" alt="" className="h-10 w-10" />
);

export const HubSpotLogo = () => (
  <img src="/hubspot-logo.svg" alt="" className="h-10 w-10" />
);

export const AsanaLogo = () => (
  <img src="/asana-logo.svg" alt="" className="h-10 w-10" />
);

export const ZoomLogo = () => (
  <img src="/zoom-logo.svg" alt="" className="h-10 w-10" />
);

export const ZendeskLogo = () => (
  <img src="/zendesk-logo.svg" alt="" className="h-10 w-10" />
);

export const getIntegrationLogo = (provider: string): React.ReactNode => {
  switch (provider) {
    case IntegrationProvider.JIRA:
      return <img src="/jira-logo.svg" alt="" className="h-8 w-8" />;
    case IntegrationProvider.SHAREPOINT:
      return <img src="/sharepoint-logo.svg" alt="" className="h-8 w-8" />;
    case IntegrationProvider.DYNAMICS_CRM:
      return <img src="/dynamics-crm-logo.svg" alt="" className="h-8 w-8" />;
    case IntegrationProvider.CONFLUENCE:
      return <img src={confluenceIcon} alt="" className="h-8 w-8" />;
    default:
      return <Link2 className="h-8 w-8 text-muted-foreground" />;
  }
};
